var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title-ch":"隱私權政策","title-en":"PRIVACY POLICY"}})
}
var staticRenderFns = []

export { render, staticRenderFns }